import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { BusinessAreaListComponent } from '@fi-app/business-area/business-area-list/business-area-list.component';

export const FiBusinessAreaListState: Ng2StateDeclaration = {
    name: FiStateNames.BusinessArea.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: BusinessAreaListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, FiBusinessAreaListStateResolve_pageTitle],
    },
};

export function FiBusinessAreaListStateResolve_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleByItem(ObjectTypes.BusinessArea);
}
